import { sentenceCase } from 'change-case';
import { filter } from 'lodash';
import { useEffect, useState } from 'react';
// material
import CloseIcon from '@mui/icons-material/Close';
import {
  Button,
  Card,
  Checkbox,
  Container,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  IconButton,
  Stack,
  Table,
  TableBody,
  TableCell,
  tableCellClasses,
  TableContainer,
  TableRow,
  TextField,
  Typography
} from '@mui/material';
import { styled } from '@mui/material/styles';
import { Box } from '@mui/system';
import { MdEmail, MdTextsms } from 'react-icons/md';
import { RiWhatsappFill } from 'react-icons/ri';
import BrudCrumbs from '../../components/BreadCrumbs';
import PageTitle from '../../components/PageHeading';
import Page from '../../components/Page';

// components
import Label from '../../components/Label';
import Scrollbar from '../../components/Scrollbar';
import SearchNotFound from '../../components/SearchNotFound';
import { UserListHead, UserMoreMenu } from '../../components/_dashboard/user';
//
import { fDate, fDateTime2 } from '../../utils/formatTime';
import Loader from '../Global/Loader';
import { CommonApiforJourney } from '../services/RecommendationApi';
import RecommendationToolbar from './RecommendationToolbar';
import { NOT_AVAILABLE } from '../Global/Constants';
import ApiErrorMessage from '../Global/ApiErrorMessage';
import useLoginSelector from '../../store/Slice/Login/LoginSelector';

// ----------------------------------------------------------------------

const TABLE_HEAD = [
  { id: 'id', label: 'Prospect ID', alignRight: false },
  { id: 'created', label: 'Prospect Date', alignRight: false },
  { id: 'name', label: 'Prospect Name', alignRight: false },
  { id: 'randomPhoneNumber', label: 'Mobile', alignRight: false },
  { id: 'loanType', label: 'Loan Type', alignRight: false },
  { id: 'applicantType', label: 'Employment Type', alignRight: false },
  { id: 'city', label: 'City', alignRight: false },
  { id: 'completion', label: 'Completion %', alignRight: false },
  { id: 'statusRecommendation', label: 'Status', alignRight: false },
  { id: 'modifiedOn', label: 'Last Update On', alignRight: false },
  { id: 'action', label: 'ACTION' }
];

// ----------------------------------------------------------------------

function descendingComparator(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

function getComparator(order, orderBy) {
  return order === 'desc'
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}

function applySortFilter(array, comparator, query) {
  const stabilizedThis = array.map((el, index) => [el, index]);
  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) return order;
    return a[1] - b[1];
  });
  if (query) {
    return filter(array, (user) => user.name.toLowerCase().indexOf(query.toLowerCase()) !== -1);
  }
  return stabilizedThis.map((el) => el[0]);
}
/**
 * Represents a book.
 * @constructor
 * @param {string} title - The title of the book.
 * @param {string} author - The author of the book.
 */
export default function Recommendation() {
  const [page, setPage] = useState(0);
  const [order, setOrder] = useState('desc');
  const [selected, setSelected] = useState([]);
  const [orderBy, setOrderBy] = useState('');
  const [filterName, setFilterName] = useState('');
  const [rowsPerPage, setRowsPerPage] = useState(500);
  const [convertLead, setConvertLead] = useState(false);
  const [sharePopUp, setSharePopUp] = useState(false);
  const [isActive, setActive] = useState(false);
  const [openApiError, setOpenApiError] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const [refreshComp, setRefreshComp] = useState('');

  const toggleClass = (box) => {
    setActive(box);
  };
  const [filterState, setFilterState] = useState({
    product: ' ',
    productId: null,
    productArray: [],
    city: null,
    cityId: null,
    cityArray: [],
    status: ' ',
    statusId: null,
    statusArray: [],
    employmentType: ' ',
    employmentTypeId: null,
    employmentTypeArray: []
  });

  const [filterDatesRange, setFilterDatesRange] = useState([
    {
      startDate: null,
      endDate: null,
      key: 'selection'
    }
  ]);
  const [openLoader, setOpenLoader] = useState(false);
  const [recommendationListState, setRecommendationListState] = useState([]);
  const { LoginData } = useLoginSelector();

  useEffect(() => {
    const objPayload = {
      filterName: filterName,
      filterDatesRange: filterDatesRange,
      filterState: filterState,
      order: order
    };
    recommendationApiFire('recommendationList', objPayload);
  }, [filterName, filterDatesRange, filterState, refreshComp]);

  const recommendationApiFire = async (type, condition) => {
    const viewRecommendationData = JSON.parse(localStorage.getItem('viewRecommendation'));
    const companyIdObj = {
      companyId: LoginData?.companyId,
      userId: LoginData?.userId,
      accessLevelId: LoginData?.accessLevelId
    };
    let methodName = '';
    let endapiPath = '';
    const token = LoginData?.jwt;
    if (type === 'recommendationList') {
      companyIdObj.recommendationFilterModel = {
        cityId: condition !== null ? condition.filterState.cityId : null,
        empTypeId: condition !== null ? condition.filterState.employmentTypeId : null,
        fromLeadDate:
          condition.filterDatesRange[0].startDate !== null
            ? fDateTime2(condition.filterDatesRange[0].startDate)
            : null,
        loanId: condition !== null ? condition.filterState.productId : null,
        statusId: condition !== null ? condition.filterState.statusId : null,
        toLeadDate:
          condition.filterDatesRange[0].endDate !== null
            ? fDateTime2(condition.filterDatesRange[0].endDate)
            : null
      };

      companyIdObj.searchAndPaginationModel = {
        searchLiteral: condition !== null ? condition.filterName : null,
        sortOrder: condition !== null ? condition.order : null
      };
      console.log('companyIdObjcompanyIdObj', companyIdObj);
      methodName = 'POST';
      endapiPath = 'recommendation/list';
    }
    //  else if (type === 'Convert to Lead') {
    //   console.log('condition', condition);
    //   console.log('condition-selected', selected);
    //   if (viewRecommendationData !== null) {
    //     companyIdObj.recommendationId = viewRecommendationData.recommendationId;
    //     companyIdObj.preferredBankId = viewRecommendationData.preferredBankId;
    //     methodName = 'PUT';
    //     endapiPath = `recommendation/convert`;
    //   }
    // }
    recommendationApiFireResponse(
      type,
      methodName,
      endapiPath,
      JSON.stringify(companyIdObj),
      token,
      ''
    );
  };

  const recommendationApiFireResponse = async (
    type,
    method,
    endpoint,
    credentials,
    authToken,
    frmData
  ) => {
    setOpenLoader(true);
    const responseData = await CommonApiforJourney(
      method,
      endpoint,
      credentials,
      authToken,
      frmData
    );
    if (responseData.status === 'success' || responseData.action_status === 'success') {
      setOpenLoader(false);
      if (type === 'recommendationList') {
        setRecommendationListState(responseData.data.recommendations);
      }
      // else if (type === 'Convert to Lead') {
      //   setConvertLead(true);
      // }
    } else {
      setOpenLoader(false);
      setRecommendationListState([]);
      setOpenApiError(true);
      setErrorMessage('Something went wrong');
    }
  };

  const handleRequestSort = (event, property) => {
    if (property !== 'action') {
      setOrder(orderBy === property && order === 'asc' ? 'desc' : 'asc');
      setOrderBy(property);
    }
  };

  const handleSelectAllClick = (event) => {
    if (event.target.checked) {
      const newSelecteds = recommendationListState.map((n) => n);
      setSelected(newSelecteds);
      return;
    }
    setSelected([]);
  };

  const handleFilterByName = (event) => {
    setFilterName(event.target.value);
  };

  const handleClick = (event, item) => {
    const selectedIndex = selected.indexOf(item);
    let newSelected = [];
    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, item);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1));
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(
        selected.slice(0, selectedIndex),
        selected.slice(selectedIndex + 1)
      );
    }
    setSelected(newSelected);
  };

  const StyledTableRow = styled(TableRow)(({ theme }) => ({
    '&:nth-of-type(odd)': {
      backgroundColor: theme.palette.action.hover
    },
    // hide last border
    '&:last-child td, &:last-child th': {
      border: 0
    }
  }));
  const StyledTableCell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
      fontSize: 13,
      fontWeight: 'bold',
      padding: '6px'
    },
    [`&.${tableCellClasses.body}`]: {
      fontSize: 11,
      padding: '4px 6px'
    }
  }));

  return (
    <Page title="Klass Management System || Recommendation">
      <Container maxWidth="xl">
        <Box pt={3} pb={3} mb={4}>
          <Stack
            direction="row"
            alignItems="center"
            justifyContent="space-between"
            className="pageHeading"
          >
            <PageTitle info="Recommendation" />
            <Box>
              <BrudCrumbs />
            </Box>
          </Stack>
          <Card>
            <RecommendationToolbar
              numSelected={selected.length}
              filterName={filterName}
              setFilterName={setFilterName}
              onFilterName={handleFilterByName}
              filterDatesRange={filterDatesRange}
              setFilterDatesRange={setFilterDatesRange}
              filterState={filterState}
              setFilterState={setFilterState}
              selected={selected}
              setConvertLead={setConvertLead}
              setOpenLoader={setOpenLoader}
              setOpenApiError={setOpenApiError}
              setErrorMessage={setErrorMessage}
            />
            <Scrollbar>
              <TableContainer sx={{ minWidth: 800, height: '69vh', overflow: 'auto' }}>
                <Table>
                  <UserListHead
                    order={order}
                    orderBy={orderBy}
                    headLabel={TABLE_HEAD}
                    rowCount={recommendationListState.length}
                    numSelected={selected.length}
                    // onRequestSort={handleRequestSort}
                    onSelectAllClick={handleSelectAllClick}
                    isCheckBox="true"
                  />
                  <TableBody>
                    {recommendationListState !== undefined && recommendationListState.length > 0
                      ? recommendationListState.map((item, index) => {
                          const isItemSelected = selected.indexOf(item) !== -1;
                          return (
                            <StyledTableRow
                              hover
                              // key={item.partnerRecommendationId}
                              key={index}
                              tabIndex={-1}
                              role="checkbox"
                              selected={isItemSelected}
                              aria-checked={isItemSelected}
                            >
                              <TableCell padding="checkbox">
                                <Checkbox
                                  checked={isItemSelected}
                                  onChange={(event) => handleClick(event, item)}
                                />
                              </TableCell>
                              <StyledTableCell align="left">
                                {item?.partnerRecommendationId !== null &&
                                item?.partnerRecommendationId !== undefined &&
                                item?.partnerRecommendationId !== ''
                                  ? item?.partnerRecommendationId
                                  : `${NOT_AVAILABLE}`}
                              </StyledTableCell>
                              <StyledTableCell align="left">
                                {item.createdOn !== null &&
                                item.createdOn !== undefined &&
                                item.createdOn !== ''
                                  ? fDate(item.createdOn)
                                  : `${NOT_AVAILABLE}`}
                              </StyledTableCell>
                              <StyledTableCell align="left">
                                {item?.name !== null &&
                                item?.name !== undefined &&
                                item?.name !== ''
                                  ? item?.name
                                  : `${NOT_AVAILABLE}`}
                              </StyledTableCell>
                              <StyledTableCell align="left">
                                {item?.mobile !== null &&
                                item?.mobile !== undefined &&
                                item?.mobile !== ''
                                  ? item?.mobile
                                  : `${NOT_AVAILABLE}`}
                              </StyledTableCell>
                              <StyledTableCell align="left">
                                {item?.loanType !== null &&
                                item?.loanType !== undefined &&
                                item?.loanType !== ''
                                  ? item?.loanType?.parentLoanName
                                  : `${NOT_AVAILABLE}`}
                              </StyledTableCell>
                              <StyledTableCell align="left">
                                {item?.empType !== null &&
                                item?.empType !== undefined &&
                                item?.empType !== ''
                                  ? item?.empType?.employmentCategoryName
                                  : `${NOT_AVAILABLE}`}
                              </StyledTableCell>
                              <StyledTableCell align="left">
                                {item?.city !== null &&
                                item?.city !== undefined &&
                                item?.city !== ''
                                  ? item?.city?.cityName
                                  : `${NOT_AVAILABLE}`}
                              </StyledTableCell>
                              <StyledTableCell align="left">
                                {' '}
                                {item?.recommendationCompletionPercentage !== null &&
                                item?.recommendationCompletionPercentage !== undefined &&
                                item?.recommendationCompletionPercentage !== ''
                                  ? item?.recommendationCompletionPercentage
                                  : `${NOT_AVAILABLE}`}
                              </StyledTableCell>
                              <StyledTableCell align="left">
                                <Label
                                  variant="ghost"
                                  color={
                                    (item?.recommendationStatus?.typeName === 'Not Completed' &&
                                      'error') ||
                                    'success'
                                  }
                                >
                                  {/* {sentenceCase(item?.recommendationStatus?.typeName)} */}
                                  {item?.recommendationStatus?.typeName
                                    ? item?.recommendationStatus?.typeName
                                    : `${NOT_AVAILABLE}`}
                                </Label>
                              </StyledTableCell>
                              <StyledTableCell align="left">
                                {item?.lastUpdatedOn !== null &&
                                item?.lastUpdatedOn !== undefined &&
                                item?.lastUpdatedOn !== ''
                                  ? fDate(item.lastUpdatedOn)
                                  : `${NOT_AVAILABLE}`}
                              </StyledTableCell>

                              <StyledTableCell align="" width={115}>
                                <UserMoreMenu
                                  rowId={item}
                                  parent="view-recommendation"
                                  recommendationApiFire={recommendationApiFire}
                                />
                              </StyledTableCell>
                            </StyledTableRow>
                          );
                        })
                      : ''}
                  </TableBody>
                  {recommendationListState.length === 0 && (
                    <TableBody>
                      <TableRow>
                        <StyledTableCell align="center" colSpan={12} sx={{ py: 3 }}>
                          <SearchNotFound searchQuery={filterName} />
                        </StyledTableCell>
                      </TableRow>
                    </TableBody>
                  )}
                </Table>
              </TableContainer>
            </Scrollbar>

            <Loader openLoader={openLoader} />
            <ApiErrorMessage
              openApiError={openApiError}
              setOpenApiError={setOpenApiError}
              select
              errorMessage={errorMessage}
            />

            {/* Share popup start */}
            <Dialog open={sharePopUp} onClose={(e) => setSharePopUp(false)} fullWidth>
              <DialogTitle className="popupTitle">
                <Typography variant="h6">Select Sharing Option</Typography>
                <IconButton onClick={(e) => setSharePopUp(false)} size="small">
                  <CloseIcon />
                </IconButton>
              </DialogTitle>
              <DialogContent dividers>
                <Box className="displayFlex alignItemCenter justifyContentCenter" mb={2}>
                  <Box
                    className={
                      isActive === 'whatsapp' ? 'mailSMSType mr-2 active' : 'mailSMSType mr-2'
                    }
                    onClick={(e) => toggleClass('whatsapp')}
                  >
                    <RiWhatsappFill color="#2CB742" size={48} />
                  </Box>
                  <Box
                    className={
                      isActive === 'email' ? 'mailSMSType mr-2 active' : 'mailSMSType mr-2'
                    }
                    onClick={(e) => toggleClass('email')}
                  >
                    <MdEmail color="#0d4689" size={48} />
                  </Box>
                  <Box
                    className={isActive === 'sms' ? 'mailSMSType mr-2 active' : 'mailSMSType mr-2'}
                    onClick={(e) => toggleClass('sms')}
                  >
                    <MdTextsms color="#4fbbc8" size={48} />
                  </Box>
                </Box>
                <FormControl required fullWidth className="formGroup">
                  <Typography variant="body1" className="formLabel">
                    Email/Mobile
                  </Typography>
                  <TextField
                    fullWidth
                    inputProps={{ className: 'textInput' }}
                    placeholder="Enter Email/Mobile"
                  />
                </FormControl>
              </DialogContent>
              <DialogActions>
                <Button
                  onClick={(e) => setSharePopUp(false)}
                  variant="contained"
                  className="mainBtn"
                >
                  Send
                </Button>
              </DialogActions>
            </Dialog>
            {/* Share popup end */}

            {/* Convert popup start */}
            <Dialog open={convertLead} onClose={(e) => setConvertLead(false)} fullWidth>
              <DialogContent dividers>
                <Box className="" py={2}>
                  Your Recommendation has been successfully converted to leads.
                </Box>
              </DialogContent>
              <DialogActions>
                <Button
                  onClick={(e) => {
                    setConvertLead(false);
                    setSelected([]);
                    setRefreshComp(new Date());
                  }}
                  variant="contained"
                  className="mainBtn"
                >
                  Close
                </Button>
              </DialogActions>
            </Dialog>
            {/* Share popup end */}
          </Card>
        </Box>
      </Container>
    </Page>
  );
}
